import React from 'react';
import cx from 'classnames';
import {observer} from 'mobx-react';
import {isRTL} from '../../../../../Localization';
import {Flex, Icon, noop, PriorityIcon} from '@priority-software/priority-style-react';
import {closeFormBySession} from '../../../actions/form';
import {Breadcrumbs} from '../Breadcrumbs';
import {formsStore} from '../../../../../stores/Form/FormsStore';
import {BackButton} from '../BackButton';
import {UpdateStatus} from '../UpdateStatus';
import {undoAction} from '../../../actions/undo';
import {HeaderHelpButton} from '../../../../../components/commonOldtoNew';
import style from './styles.module.scss';
import {createDataTestId} from '../../../../../utils/dataTestId';

type Props = {
    session: string;
    breadcrumbs: any;
    onBreadCrumbClick: (level: number, session: string) => void;
    componentClasses?: string;
};

export const ScreenHeader = observer(
    ({session, breadcrumbs, onBreadCrumbClick, componentClasses}: Props) => {
        const closeScreen = async () => {
            const activeForm = formsStore.getActiveForm();
            if (activeForm.parentForm) {
                const isValidAction = await formsStore.currentScreen.handleFormLevel(
                    activeForm.parentForm?.level
                );
                if (isValidAction) {
                    closeScreen();
                }
            } else {
                closeFormBySession(session, !screen?.zoomSource);
            }
        };
        const screen = formsStore.getScreenBySession(session);

        return (
            <Flex
                componentClasses={cx(style.header, componentClasses)}
                alignItems="center"
                justifyContent="space-between"
                {...createDataTestId('screen-title-container', true)}
            >
                <Flex justifyContent="flex-start">
                    <Breadcrumbs data={breadcrumbs} onItemClick={onBreadCrumbClick} />
                    {screen?.zoomSource &&
                        formsStore.getActiveForm()?.level === 0 &&
                        formsStore.getActiveForm()?.searchModeLevel === 0 && (
                            <BackButton screen={screen} />
                        )}
                    <Icon
                        componentClasses={style.favoriteBtn}
                        icon={PriorityIcon.starEmpty}
                        onClick={noop}
                    />
                </Flex>

                <Flex justifyContent="flex-end">
                    <UpdateStatus session={session} />

                    <Icon
                        componentClasses={style.undoBtn}
                        onClick={undoAction}
                        icon={PriorityIcon.refresh}
                    />
                    <Icon
                        componentClasses={style.itemMargin}
                        onClick={noop}
                        icon={PriorityIcon.settings}
                    />

                    <div className={style.divider} />

                    <HeaderHelpButton
                        tooltipPosition="bottom-end"
                        iconComponentClasses={isRTL() ? style.paddingLeft : style.paddingRight}
                    />

                    <Icon
                        icon={PriorityIcon.closeBig}
                        onClick={closeScreen}
                        componentClasses={style.closeIcon}
                    />
                </Flex>
            </Flex>
        );
    }
);
